export default __webpack_public_path__ + "static/media/pdf.61f9fe36.png";